/**
 * WebAudio sound core (no external audio files)
 * Plays ONLY when unlocked by user gesture (browser policy).
 */

let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  audioCtx = new Ctx();
  return audioCtx;
}

export function primeAudio() {
  const ctx = getCtx();
  if (!ctx) return false;
  // resume may be required by some browsers
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return true;
}

function beep({ freq = 880, durationMs = 120, gain = 0.06 } = {}) {
  const ctx = getCtx();
  if (!ctx) return;

  if (ctx.state === "suspended") {
    // if not unlocked — do nothing
    return;
  }

  const osc = ctx.createOscillator();
  const g = ctx.createGain();

  osc.type = "sine";
  osc.frequency.value = freq;

  g.gain.value = gain;

  osc.connect(g);
  g.connect(ctx.destination);

  const now = ctx.currentTime;
  osc.start(now);
  osc.stop(now + durationMs / 1000);
}

export function playPattern(name = "default") {
  // Small distinct patterns
  switch (name) {
    case "chat":
      beep({ freq: 880, durationMs: 90 });
      setTimeout(() => beep({ freq: 1175, durationMs: 90 }), 120);
      break;
    case "order":
      beep({ freq: 523, durationMs: 140 });
      setTimeout(() => beep({ freq: 659, durationMs: 140 }), 180);
      setTimeout(() => beep({ freq: 784, durationMs: 160 }), 360);
      break;
    case "status":
      beep({ freq: 740, durationMs: 130 });
      break;
    default:
      beep({ freq: 880, durationMs: 110 });
  }
}
